import type { FaireProductEntity } from "../../entity_types/product";

export const p_nsv7g3xqf5: FaireProductEntity = {
  token: "p_nsv7g3xqf5",
  type: "product",
  name: "Hummingbird Crew Socks",
  brandToken: "b_46c570c5",
  brandName: "Solmate Socks",
  imageUrl:
    "https://cdn.faire.com/fastly/f9a5fe0e77d0207e5cf1172e4741536bef2f3c4919a6805b3c48f457ca57502a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1c5a71fed402b817955208e27ac3becb502fd5f55545e4d9fa1fc6e6118227f2.jpeg",
    "https://cdn.faire.com/fastly/0fae56f508d9eb54777bc5f7f252a5f5170388e4f3992b564cc0cc14e428bccd.jpeg",
    "https://cdn.faire.com/fastly/e8fae77eca628b265c67642ac85c991782127711f860ae5d077d46019fac7495.jpeg",
    "https://cdn.faire.com/fastly/03488553b18ed52c024b8b30d7043c29c547f78417038fc80b808f9706b0ef9a.jpeg",
    "https://cdn.faire.com/fastly/0a76a8e8f581f77c9384141d829cb03d7c46db88a5a4d930a7ff2ae1f826291c.jpeg",
  ],
  priceDollars: 9.25,
  description:
    "\nIntroducing the Hummingbird Crew Socks, a member of our Give Back Collection! A portion of the proceeds from these socks will be donated to the International Hummingbird Society, whose mission focuses on teaching about hummingbirds and working internationally to protect them. This nonprofit is dedicated to helping endangered hummingbirds through conservation efforts, and educates others with their annual Sedona Hummingbird Festival. Colors in this sock: Turquoise, Pink, Pale Yellow, Green, White, and Royal Blue.\n\nMade With: 62% Recycled Cotton, 22% Recycled Polyester, 15% Nylon, 1% Spandex\n\n",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:30.883Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
